import request from "@/utils/request";

// 获取通知相关的文件列表
export function getDocumentListByApplicationId(params) {
  return request({
    url: "/cloud/application/documentList",
    method: "get",
    params: params
  });
}

export function saveDocument(data) {
  return request({
    url: "/cloud/application/document",
    method: "post",
    data: data
  });
}

export function getDocumentUnreceivedCount(applicationId) {
  return request({
    url: "/cloud/application/document/unreceivedCount?applicationId=" + applicationId,
    method: "get"
  });
}

export function deleteDocumentById(id) {
  return request({
    url: "/cloud/application/document/deleteById?id=" + id,
    method: "post"
  });
}

//签收文件
export function documentReceive(data) {
  return request({
    url: "/cloud/application/document/receive",
    method: "post",
    data: data
  });
}

